import {useSelector} from 'react-redux';
import {UserRole, AdminRole} from '@/constants/enums';
import {authDataSelector} from '@/services/redux/selectors';

export function useRole() {
  const authData = useSelector(authDataSelector);

  const isPatient = authData?.role === UserRole.PATIENT;
  const isAdmin = authData?.role === UserRole.ADMIN;
  const isSuperAdmin = authData?.role === UserRole.SUPER_ADMIN;
  const isSpecialist = authData?.role === UserRole.SPECIALIST;
  const isHospitalPoc = authData?.role === UserRole.HOSPITAL_POC;

  // Check admin roles based on scope
  const isPatientAdmin = isAdmin && authData?.scope === AdminRole.PatientAdmin;
  const isFinanceAdmin = isAdmin && authData?.scope === AdminRole.FinanceAdmin;
  const isSpecialistAdmin = isAdmin && authData?.scope === AdminRole.SpecialistAdmin;
  const isSupportAdmin = isAdmin && authData?.scope === AdminRole.SupportAdmin;
  const isHospitalAdmin = isAdmin && authData?.scope === AdminRole.HospitalAdmin;

  return {
    isPatient,
    isAdmin,
    isSuperAdmin,
    isSpecialist,
    isHospitalPoc,
    isPatientAdmin,
    isFinanceAdmin,
    isSpecialistAdmin,
    isSupportAdmin,
    isHospitalAdmin,
  };
}
